module.exports = __webpack_public_path__ + "img/t1.68ba0d97.png";